import { NSMenuActionProps } from "namirasoft-site-react";
import { WorkspaceProps } from "./WorkspaceProps";
import { NSARouterMakerResult } from "namirasoft-account-react";

export class WorkspaceMenus
{
	static setDefault(props: NSARouterMakerResult & WorkspaceProps, getIDs: () => string[], callback: () => void): NSMenuActionProps
	{
		return {
			id: "1",
			menu_item: "Set Default",
			isActive: () =>
			{
				return getIDs().length === 1;
			},
			onClick: {
				action: (onFinished) =>
				{
					let id = getIDs()[0];
					props.servers.workspace.workspace.SetDefault(id).then(() =>
					{
						props.notifier.onSuccess("The default workspace was switched successfully.");
						callback();
						onFinished();
					}).catch(onFinished);
				}
			}
		};
	}
	static setCurrent(props: NSARouterMakerResult & WorkspaceProps, getIDs: () => string[], callback: () => void): NSMenuActionProps
	{
		return {
			id: "2",
			menu_item: "Set Current",
			isActive: () =>
			{
				return getIDs().length === 1;
			},
			onClick: {
				action: (onFinished) =>
				{
					let id = getIDs()[0];
					props.servers.workspace.workspace.SetCurrent(id).then(() =>
					{
						props.notifier.onSuccess("The default workspace was switched successfully.");
						callback();
						onFinished();
					}).catch(onFinished);
				}
			}
		};
	}
}